/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Defect_Shelf_Err_Allow_Sale_Needs_ShelfInputs */

const vi_defect_shelf_err_allow_sale_needs_shelf = /** @type {(inputs: Defect_Shelf_Err_Allow_Sale_Needs_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ bật "Cho phép bán" trên kệ hàng lỗi.`)
};

/**

* @param {Defect_Shelf_Err_Allow_Sale_Needs_ShelfInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const defect_shelf_err_allow_sale_needs_shelf = /** @type {((inputs?: Defect_Shelf_Err_Allow_Sale_Needs_ShelfInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defect_Shelf_Err_Allow_Sale_Needs_ShelfInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_defect_shelf_err_allow_sale_needs_shelf(inputs)
});